var _path, _g, _path2, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFav2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_980_39429",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 30V0H29.9906V30H0Z",
    fill: "#FFFFFE"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_980_39429)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4157 13.5852C23.3716 10.9952 21.2703 8.6875 18.6751 8.6875C17.1741 8.6875 15.8519 9.47268 14.9814 10.6246C14.1108 9.47268 12.7881 8.6875 11.2876 8.6875C8.69242 8.6875 6.59111 10.9952 6.54702 13.5852H6.53857C6.53857 13.6007 6.54186 13.6157 6.54186 13.6317C6.54186 13.6429 6.53857 13.6547 6.53857 13.6673C6.53857 13.74 6.5564 13.7954 6.55968 13.8648C6.79186 20.4652 14.9147 23.1711 14.9147 23.1711C14.9147 23.1711 23.1572 20.468 23.4011 13.8756C23.4049 13.8015 23.4241 13.7433 23.4241 13.6673C23.4241 13.6547 23.4208 13.6429 23.4208 13.6317C23.4208 13.6148 23.4241 13.6007 23.4241 13.5852H23.4157Z",
    fill: "#FF0025"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_980_39429",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 30V0H29.9906V30H0Z",
    fill: "#4C5665"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_980_39429)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4238 13.6672C23.4238 13.7432 23.4046 13.8013 23.4009 13.8754C23.157 20.4678 14.9145 23.1709 14.9145 23.1709C14.9145 23.1709 6.79157 20.465 6.55939 13.8647C6.55611 13.7952 6.53828 13.7399 6.53828 13.6672C6.53828 13.6545 6.54157 13.6428 6.54157 13.6315C6.54157 13.6156 6.53828 13.6006 6.53828 13.5851H6.54673C6.59082 10.995 8.69213 8.68736 11.2873 8.68736C12.7878 8.68736 14.1105 9.47253 14.9811 10.6245C15.8516 9.47253 17.1738 8.68736 18.6748 8.68736C21.27 8.68736 23.3713 10.995 23.4154 13.5851H23.4238C23.4238 13.6006 23.4206 13.6147 23.4206 13.6315C23.4206 13.6428 23.4238 13.6545 23.4238 13.6672ZM14.9811 -0.0185547C6.69166 -0.0185547 -0.0283203 6.70143 -0.0283203 14.9908C-0.0283203 23.2802 6.69166 30.0002 14.9811 30.0002C23.2705 30.0002 29.9904 23.2802 29.9904 14.9908C29.9904 6.70143 23.2705 -0.0185547 14.9811 -0.0185547Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFav2);
export default __webpack_public_path__ + "static/media/fav2.79a6e56213e0df78e4a753b600569bc2.svg";
export { ForwardRef as ReactComponent };